module.exports = __webpack_public_path__ + "img/hand-thumbs-down.084e1328.svg";